var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOffers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9995 7.29102L14.6849 10.7067L18.454 11.2543L15.7267 13.9128L16.3704 17.6667L12.9995 15.8939L9.62856 17.6667L10.2722 13.9128L7.54492 11.2543L11.314 10.7067L12.9995 7.29102Z",
    stroke: "#BA8926",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25C19.6274 25 25 19.6274 25 13C25 6.37258 19.6274 1 13 1C6.37258 1 1 6.37258 1 13C1 19.6274 6.37258 25 13 25Z",
    stroke: "#BA8926",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9991 21.7287C13.6016 21.7287 14.09 21.2403 14.09 20.6378C14.09 20.0353 13.6016 19.5469 12.9991 19.5469C12.3966 19.5469 11.9082 20.0353 11.9082 20.6378C11.9082 21.2403 12.3966 21.7287 12.9991 21.7287Z",
    fill: "#BA8926"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2618 16.4494C20.8643 16.4494 21.3527 15.961 21.3527 15.3585C21.3527 14.756 20.8643 14.2676 20.2618 14.2676C19.6593 14.2676 19.1709 14.756 19.1709 15.3585C19.1709 15.961 19.6593 16.4494 20.2618 16.4494Z",
    fill: "#BA8926"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4884 7.91424C18.0909 7.91424 18.5793 7.42582 18.5793 6.82333C18.5793 6.22084 18.0909 5.73242 17.4884 5.73242C16.8859 5.73242 16.3975 6.22084 16.3975 6.82333C16.3975 7.42582 16.8859 7.91424 17.4884 7.91424Z",
    fill: "#BA8926"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51181 7.91424C9.1143 7.91424 9.60272 7.42582 9.60272 6.82333C9.60272 6.22084 9.1143 5.73242 8.51181 5.73242C7.90932 5.73242 7.4209 6.22084 7.4209 6.82333C7.4209 7.42582 7.90932 7.91424 8.51181 7.91424Z",
    fill: "#BA8926"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73837 16.4494C6.34086 16.4494 6.82928 15.961 6.82928 15.3585C6.82928 14.756 6.34086 14.2676 5.73837 14.2676C5.13588 14.2676 4.64746 14.756 4.64746 15.3585C4.64746 15.961 5.13588 16.4494 5.73837 16.4494Z",
    fill: "#BA8926"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffers);
export default __webpack_public_path__ + "static/media/offers.c35b1e538b0d55e44bbb16ddb0945244.svg";
export { ForwardRef as ReactComponent };